import React, {useEffect, useState, useTransition} from "react";
import AppInterface from "app/layouts/AppInterface";
import {INPUT_FILE_MAX_SIZE, Keys, ModuleFieldsData, Modules} from "../../config/AppConfig";
import {useTheme} from "../../../common/ProjectThemeProvider";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {
    changeStringCase,
    checkNullJson,
    checkNullStr,
    createTimeout,
    getJsonValue,
    getDefStr,
    isBoolTrue,
    setTabTitle
} from "../../../common/fusion-ui/utils/ReactUtils";
import {getUserSessionData, getUserSessionField, isCurrUserRoleAdmin, printError, printLog} from "../../utils/AppUtils";
import {Anchor, Avatar, Flexbox, GridBox, Label, LoadingSection, Section} from "../../../common/fusion-ui";
import {ThemedButton, ThemedDrawer, UserProfile_Edit_FormPanel} from "../../index";
import {CssVariant, DefStrNA} from "../../../common/fusion-ui/config/FusionConfig";
import {useConfig} from "../../context/ConfigProvider";


const UserProfilePage = React.memo(() => {
    const TAG = 'UserProfilePage';

    const moduleName = Modules.UserProfile;
    const mf = ModuleFieldsData[moduleName];

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isConfigTrue, updateConfig} = useConfig();
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();
    const [pending, startTransition] = useTransition();


    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        // cardEditModeOn: 'cardEditModeOn',
        // psnlInfoEditModeOn: 'psnlInfoEditModeOn',
    };
    const [fieldsData, setFieldsData] = useState({});
    const [profileData, setProfileData] = useState({});
    // const [profileData, setProfileData] = useState(getUserSessionData());

    const [openEditFormDrawer, setOpenEditFormDrawer] = useState(false);

    useEffect(() => {
        setTabTitle(moduleName);
        // updateConfig(Keys.config_navbarCurrPage, moduleName);
        // updateConfig(Keys.config_navbarCurrPage, '');
        // updateConfig(Keys.config_ShowTabBar, false);
        // updateConfig(Keys.config_TabBarTab, -1);
        // updateConfig(Keys.tracker_currPageModule, moduleName);
        // updateConfig(Keys.tracker_currPageTag, TAG);

        updateConfig(Keys.config_ShowTabBar, false);
        updateConfig(Keys.config_navbarCurrPage, moduleName);
        updateConfig(Keys.tracker_currPageModule, moduleName);
        updateConfig(Keys.tracker_currPageTag, TAG);

        if (!isFieldTrue(Fields.isDataFetched)) {
            updateField(Fields.isDataFetched, true);
            const userData = getUserSessionData();
            // log('useEffect.userData:', userData);
            updateField(Fields.isDataLoading, true);
            createTimeout(() => {
                if (!checkNullJson(profileData)) {
                    setProfileData(userData);
                }
                updateField(Fields.isDataLoading, false);
                updateField(Fields.isDataFound, checkNullJson(userData));
                updateField(Fields.dataLoadingMsg, '');
            }, 200);
        }
    }, []);

    return (<>
        <AppInterface
            label={moduleName}
            labelProps={{color: theme.text}}
            showHome={true}>
            <div className={''}>
                {<LoadingSection
                    labelClassName={'m-2 w-100 fs-normal'}
                    heightClass={75}
                    color={theme.text70}
                    success={isFieldTrue(Fields.isDataFound)}
                    loading={isFieldTrue(Fields.isDataLoading)}
                    msg={getField(Fields.dataLoadingMsg)}
                />}

                {/*body*/}
                {(!isFieldTrue(Fields.isDataLoading) && isFieldTrue(Fields.isDataFound)) && <div className={`m-0 p-0`}>
                    {/*top-card*/}
                    <Section
                        className={'m-0 p-3 h-auto'}
                        position={'relative'}
                        borderless={true}
                        shadowVariant={'sm border-risen-smx'}
                        borderColor={theme.text20}>
                        <Flexbox className={' w-100-sm'}
                                 justifyAt={'between'} alignAt={'center'}
                                 justifyAtSm={'center'} alignAtSm={'start'}
                                 wrapSm={'start'} directionSm={'column'}>
                            {/*left - image & details*/}
                            <Flexbox className={'m-0 p-0 w-100-sm'}
                                     justifyAt={'between'} alignAt={'center'}
                                     justifyAtSm={'center'} alignAtSm={'start'}
                                     wrapSm={'wrap'} directionSm={'column'}>
                                <div className={'w-100-sm'}>
                                    <Avatar wrapperClassName={'m-0 p-0 bg-infox '}
                                            className={''}
                                            imgClassName={''}
                                            justifyAt={'center'}
                                            alignAt={'center'}
                                            circular={true}
                                            bordered={false}
                                            editTooltip={`Edit (.jpg, .jpeg, .png)`}
                                            size={'130px'}
                                            editSize={'24px'}
                                            editStyle={{top: '.5rem', right: '-.1rem'}}
                                        // showEdit={isFieldTrue(Fields.cardEditModeOn)}
                                            accept={'.jpg, .jpeg, .png'}
                                            showFullPreviewDialog={true}
                                            maxSize={INPUT_FILE_MAX_SIZE}
                                            onChange={(e, file, path, name, ext) => {
                                                // log('Avatar.doc.onChange.name:', name);
                                                updateUserField(mf.memberImage, file);
                                                updateUserField(mf.fileExt, ext);
                                            }}
                                            onInvalidFormat={(e, name) => {
                                                toast(`Invalid file format. File must be jpg, jpeg or png`, CssVariant.danger);
                                            }}
                                            onSizeExceeded={() => {
                                                toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                            }}
                                    >
                                        {getUserField(mf.memberImage)}
                                    </Avatar>
                                </div>

                                {/*detail-fields*/}
                                <div className={'m-0 p-0 pe-3 ps-1 d-flex jc-center w-100-sm'}>
                                    <div className={'m-0 p-0'}>
                                        {/*full-name*/}
                                        <div>
                                            {/*{!isFieldTrue(Fields.cardEditModeOn) ?*/}
                                            <Label className={'m-0 p-0 px-2 fw-semi-bold'} color={theme.text} textAt={'start'}>
                                                {getUserField(mf.fullName)}
                                            </Label>
                                            {/*: createProfileCardInputField({*/}
                                            {/*    field: mf.fullName,*/}
                                            {/*    className: 'fw-semi-bold'*/}
                                            {/*})}*/}
                                        </div>
                                        {/*email*/}
                                        {checkNullStr(getUserField(mf.memberEmail1)) && <div>
                                            {/*{isFieldTrue(Fields.cardEditModeOn)?*/}
                                            {/*    createProfileCardInputField({*/}
                                            {/*        field: mf.memberEmail1,*/}
                                            {/*        className: 'text-primary mt-1'*/}
                                            {/*    }) : */}
                                            <Anchor wrapperClassName={''}
                                                    className={'m-0x p-0 px-2'}
                                                    href={`mailto:${getUserField(mf.memberEmail1)}`}
                                                    simple={true}
                                                    textAt={'start'}>
                                                {getUserField(mf.memberEmail1)}
                                            </Anchor>
                                            {/*}*/}
                                        </div>}

                                        {/*mobile*/}
                                        {checkNullStr(getUserField(mf.memberMobile1)) && <div>
                                            {/*{isFieldTrue(Fields.cardEditModeOn)*/}
                                            {/*    ? createProfileCardInputField({*/}
                                            {/*        field: mf.memberMobile1,*/}
                                            {/*        className: 'text-primary mt-1'*/}
                                            {/*    }) :*/}
                                            <Anchor className={'m-0x p-0 px-2'}
                                                    href={`tel:${getUserField(mf.memberMobile1)}`}
                                                    simple={true}
                                                    textAt={'start'}>
                                                {getUserField(mf.memberMobile1)}
                                            </Anchor>
                                            {/*}*/}
                                        </div>}

                                        {/*memberSpeciality1*/}
                                        {checkNullStr(getUserField(mf.memberSpeciality1)) && <div>
                                            {/*{isFieldTrue(Fields.cardEditModeOn)*/}
                                            {/*    ? createProfileCardInputField({*/}
                                            {/*        field: mf.memberSpeciality1,*/}
                                            {/*        className: 'mt-1',*/}
                                            {/*        label: 'Specialty: '*/}
                                            {/*    }) :*/}
                                            <Label className={'m-0 p-0 px-2'} color={theme.text50} textAt={'start'}>
                                                <span className={'fw-semi-bold'}>Specialty: </span>
                                                <span style={{color: theme.text}}>
                                                {getUserField(mf.memberSpeciality1)}
                                            </span>
                                            </Label>
                                            {/*}*/}
                                        </div>}

                                        {/*role*/}
                                        {isCurrUserRoleAdmin() && <div>
                                            {/*{isFieldTrue(Fields.cardEditModeOn)*/}
                                            {/*    ? createProfileCardInputField({*/}
                                            {/*        field: mf.memberUser,*/}
                                            {/*        className: 'mt-1',*/}
                                            {/*        label: 'Role: '*/}
                                            {/*    })  :*/}
                                            <Label className={'m-0 p-0 px-2'} color={theme.text50} textAt={'start'}>
                                                <span className={'fw-semi-bold'}>Role: </span>
                                                <span style={{color: theme.text}}>
                                                {changeStringCase(getUserField(mf.memberUser, DefStrNA), 'capitalize', true)}
                                            </span>
                                            </Label>
                                            {/*}*/}
                                        </div>}
                                    </div>
                                </div>
                            </Flexbox>

                            {/*edit-control*/}
                            {(isCurrUserRoleAdmin()) &&
                                <div className={'m-0 p-0 d-flex jc-center bg-darkx w-100-sm'}>
                                    {<ThemedButton
                                        className={'fs-sm fw-semi-bold text-nowrap py-2'}
                                        outlined={true}
                                        sleek={true}
                                        my={2}
                                        // variant={isFieldTrue(Fields.cardEditModeOn) ? theme.primaryBlue : theme.text60}
                                        // hoverBgColor={isFieldTrue(Fields.cardEditModeOn) ? theme.primaryBlueDark : theme.primaryBlue}
                                        // icon={isFieldTrue(Fields.cardEditModeOn) ? IconClass.save : 'bi bi-pencil'}
                                        // text={isFieldTrue(Fields.cardEditModeOn) ? 'Save' : `Edit`}
                                        variant={theme.text60}
                                        hoverBgColor={theme.primaryBlue}
                                        icon={'bi bi-pencil'}
                                        text={`Edit`}
                                        onClick={() => {
                                            // updateField(Fields.cardEditModeOn, !isFieldTrue(Fields.cardEditModeOn));
                                            setOpenEditFormDrawer(true);
                                        }}
                                    />}
                                </div>}
                        </Flexbox>
                    </Section>

                    {/*personal-info*/}
                    <div className={'mt-4 pt-1'}>
                        <Section
                            className={'m-0 p-3 px-3 h-auto'}
                            position={'relative'}
                            borderless={true}
                            shadowVariant={'sm border-risen-smx'}
                            title={'Personal Information'}
                            titleClassName={'fs-normal fw-semi-bold mt-n1 px-1 mb-2'}
                            titleAt={'start'}
                            titleColor={theme.text80}
                            borderColor={theme.text20}
                            contentClassName={'px-1'}>
                            {/*edit-control*/}
                            {/*{(isCurrUserRoleAdmin() && !isFieldTrue(Fields.cardEditModeOn)) &&*/}
                            {/*    <Flexbox className={''} position={'absolute'} top={'.7rem'} right={'1.1rem'} zIndex={1}>*/}
                            {/*        <ThemedButton*/}
                            {/*            className={'fs-sm fw-semi-bold text-nowrap py-2'}*/}
                            {/*            outlined={true}*/}
                            {/*            sleek={true}*/}
                            {/*            my={2}*/}
                            {/*            icon={isFieldTrue(Fields.psnlInfoEditModeOn) ? IconClass.saveFill : 'bi bi-pencil'}*/}
                            {/*            text={isFieldTrue(Fields.psnlInfoEditModeOn) ? 'Save Info' : `Edit Info`}*/}
                            {/*            variant={isFieldTrue(Fields.psnlInfoEditModeOn) ? theme.primaryBlue : theme.text60}*/}
                            {/*            hoverBgColor={isFieldTrue(Fields.psnlInfoEditModeOn) ? theme.primaryBlueDark : theme.primaryBlue}*/}
                            {/*            onClick={handleEditSaveProfileData}*/}
                            {/*        />*/}
                            {/*    </Flexbox>}*/}

                            {/*info-fields*/}
                            <GridBox className={'px-2'} sm={12} md={6} gap={0}>
                                {createSingleInfoField('DOB', mf.memberDob)}

                                {/*non-admin can only see combine fields*/}
                                {!isCurrUserRoleAdmin() && createSingleInfoField('Email', mf.memberEmail1, mf.memberEmail2)}
                                {!isCurrUserRoleAdmin() && createSingleInfoField('Mobile', mf.memberMobile1, mf.memberMobile2)}
                                {!isCurrUserRoleAdmin() && createSingleInfoField('Gender', mf.gender)}
                                {!isCurrUserRoleAdmin() && createSingleInfoField('Designation', mf.memberDesignation1, mf.memberDesignation2)}
                                {!isCurrUserRoleAdmin() && createSingleInfoField('Organisation', mf.memberOrganisation1, mf.memberOrganisation2)}
                                {!isCurrUserRoleAdmin() && createSingleInfoField('Interest Area', mf.interestArea1, mf.interestArea2)}
                                {!isCurrUserRoleAdmin() && createSingleInfoField('Work Address', mf.workAddress1, mf.workAddress2)}
                                {!isCurrUserRoleAdmin() && createSingleInfoField('Remark', mf.memberRemark)}

                                {/*admin can see fields individually*/}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Mobile 1', mf.memberMobile1)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Mobile 2', mf.memberMobile2)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Gender', mf.gender)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Designation 1', mf.memberDesignation1)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Designation 2', mf.memberDesignation2)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Organisation 1', mf.memberOrganisation1)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Organisation 2', mf.memberOrganisation2)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Interest Area 1', mf.interestArea1)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Interest Area 2', mf.interestArea2)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Work Address 1', mf.workAddress1)}
                                {isCurrUserRoleAdmin() && createSingleInfoField('Work Address 2', mf.workAddress2)}
                            </GridBox>
                        </Section>
                    </div>
                </div>}
            </div>
        </AppInterface>
        {createCardInfoEditDrawer()}
    </>);

    function createCardInfoEditDrawer() {
        return <ThemedDrawer
            title={'Edit Profile'}
            closeOnEscape={true}
            closeOnClickAway={false}
            detached={true}
            open={openEditFormDrawer}
            onClose={() => {
                setOpenEditFormDrawer(false);
            }}>
            <UserProfile_Edit_FormPanel
                recordId={getUserSessionField('memberId')}
                asPanel={true}
                showCancel={true}
                onSuccess={(message) => {
                    log('drawer.editForm.onSuccess.message:', message);
                    setOpenEditFormDrawer(false);
                }}
                onFailure={(error) => {
                    log('drawer.editForm.onFailure.error:', error);
                }}
                onCancel={() => {
                    setOpenEditFormDrawer(false);
                }}
            />
        </ThemedDrawer>
    }

    function createSingleInfoField(label, field1, field2) {
        return <div className={''}>
            <Label className={'m-0 p-0x ps-2x ps-1x fw-semi-bold mt-n1x select-none'}
                   textAt={'start'}
                   style={{padding: '0 0 0 .75rem'}}
                   color={theme.text50}>
                {/*color={isFieldTrue(Fields.psnlInfoEditModeOn) ? theme.text80 : theme.text50}>*/}
                {label}
            </Label>
            {/*
                 <div  className={`d-flex al-center jc-start form-control transition-sm ${isFieldTrue(Fields.psnlInfoEditModeOn) ? `cursor-text text-nowrap border-primary-hover border-primary-focus border-primary-active ${!checkNullStr(getUserField(field1)) ? `` : ``}` : `cursor-default text-wrap`}`}*/}
            <div className={`d-flex al-center jc-start form-control transition-sm border-none mt-n2 mb-1`}
                 style={{
                     height: '34px',
                     // backgroundColor: theme.bg,
                     color: theme.text,
                     // color: (isFieldTrue(Fields.psnlInfoEditModeOn) && !checkNullStr(getUserField(field1))) ? theme.text40 : theme.text,
                     // borderWidth: '1.5px',
                     // borderColor: isFieldTrue(Fields.psnlInfoEditModeOn) ? theme.text20 : 'transparent',
                 }}
                // style={{border: '1px solid #ccc', padding: '8px', borderRadius: '4px', minHeight: '50px'}}
                // onBlur={(e) => {
                //     // log(`createSingleInfoField.label: ${label}.ThemedInput.onChange.value:`, value);
                //     // updateUserField(field1, value)
                //     if (isFieldTrue(Fields.psnlInfoEditModeOn)) {
                //         const value = e.target.textContent;
                //         updateUserField(field1, value);
                //     }
                // }}
                // dangerouslySetInnerHTML={{
                //     __html: isFieldTrue(Fields.psnlInfoEditModeOn)
                //         // ? (getDefStr(getUserField(field1), `Enter ${label}`))
                //         ? (getDefStr(getUserField(field1), ``))
                //         : getDefStr(getDefStr(getUserField(field1), getUserField(field2)), DefStrNA)
                // }}
                // contentEditable={isFieldTrue(Fields.psnlInfoEditModeOn) && isCurrUserRoleAdmin()}
            >{getDefStr(getUserField(field1), getUserField(field2, DefStrNA))}
            </div>
        </div>
    }

    //======================Util Functions start=====================
    function handleEditSaveProfileData() {
        const fun = 'handleEditSaveProfileData';
        try {
            // toast(isFieldTrue(Fields.psnlInfoEditModeOn) ? 'Save info clicked' : "Edit info clicked");
            // updateField(Fields.psnlInfoEditModeOn, !isFieldTrue(Fields.psnlInfoEditModeOn));
        } catch (error) {
            logErr(fun, error);
            toast("Couldn't save data, please try again!", CssVariant.danger);
        }
    }

    function getFullName() {
        return getUserField(mf.fullName);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function getUserField(colField = {}, defValue) {
        return getJsonValue(profileData, colField.column, defValue);
    }

    function updateUserField(colField = {}, value) {
        setProfileData(prevState => ({...prevState, [colField.column]: value}));
    }

    function getUserFieldTitle(colField = {}, defValue) {
        return getJsonValue(colField, 'title', defValue);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});

export default UserProfilePage;
